import { theme } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectTeams } from 'reduxStore/teams/selectors';
import TeamDrawer from 'zComponents/molecules/TeamDrawer';
import { Button, Col, Empty, Flex, Row, Typography } from 'zui/Antd';

const { Text } = Typography;

function RenderTeamsPanelContent({ searchResults = [], isSearching = false }) {
	const {
		token: {
			colorTextLabel,
			fontWeightStrong,
			padding,
			borderRadius,
			paddingSM,
			colorFill,
			colorPrimaryText,
			lineHeight,
			lineHeightLG,
			fontSizeLG
		}
	} = theme.useToken();
	const allTeamsData = useSelector(selectTeams);

	const [openDrawer, setOpenDrawer] = useState(false);
	const [selectedTeam, setSelectedTeam] = useState(null);
	const displayData = isSearching ? searchResults.map((result) => result.item) : allTeamsData;

	if (displayData.length === 0) {
		return (
			<Flex align='center' justify='center' vertical style={{ width: '100%', padding }}>
				<Empty description={isSearching ? 'No search results found' : 'No teams to display'} />
			</Flex>
		);
	}

	return (
		<Row gutter={[20, 20]} justify='start'>
			{displayData.map((team, index) => (
				<Col key={isSearching ? `search-${index}` : index} xl={8} lg={12} sm={24}>
					<Flex
						vertical
						style={{
							border: `1px solid ${colorFill}`,
							padding: paddingSM,
							borderRadius,
							boxSizing: 'border-box'
						}}
					>
						<Flex align='center' justify='space-between'>
							<Flex vertical flex={1} style={{ width: 0 }}>
								<Text
									ellipsis={{ tooltip: team?.name }}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: fontWeightStrong,
										fontSize: fontSizeLG,
										lineHeight: lineHeightLG
									}}
								>
									{team?.name || '--'}
								</Text>
								<Text
									ellipsis={{ tooltip: `Members: ${team?.members?.length ?? '0'}` }}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: 500,
										lineHeight: lineHeight
									}}
								>
									Members: {team?.members?.length ?? '--'}
								</Text>
							</Flex>
							<Button
								onClick={() => {
									setSelectedTeam(team?.teamID);
									setOpenDrawer(true);
								}}
								type='text'
								style={{ color: colorPrimaryText }}
							>
								View Team
							</Button>
						</Flex>
					</Flex>
				</Col>
			))}
			<TeamDrawer teamID={selectedTeam} visible={openDrawer} setVisible={setOpenDrawer} />
		</Row>
	);
}

export default RenderTeamsPanelContent;
